import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom';

import useQueryParams from '../hooks/useQuery'

const IntroVideo = (props) => {
  const {
    className
  } = props;
  const { t } = useTranslation('common')
  const query = useQueryParams();
  const history = useHistory();
  const [isIntroOpen, setIsIntroOpen] = useState(query.get('intro'));

  const toggle = () => { 
    history.replace(`${history.location.pathname}`)
    setIsIntroOpen(open => !open)
  }

  return (
    <div>
      {/* <Button color="danger" onClick={toggle}>{buttonLabel}</Button> */}
      <Modal isOpen={isIntroOpen} className={`intro-video ${className}`}>
        <ModalHeader toggle={toggle} className="text-center py-3"><h4 className="font-weight-bold mb-0">{t('introVideoTitle')}</h4> 
          <small className="text-muted mb-0">{t('introVideoSubtitle')}</small>
        </ModalHeader>
        <ModalBody className="bg-grey p-0">
            <div className="video-container">
              <iframe title="Trato intro tutorial" width="560" height="315" src="https://www.youtube.com/embed/TTBDxrG0QTA" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </ModalBody>
        <ModalFooter className="text-center mx-auto w-100 py-3">
          <Button color="secondary" onClick={toggle} className="mx-auto text-center">{t('introVideoButton')}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default IntroVideo;